import React, { Fragment, useState } from "react"
import { GenericCircleIcon } from "../../../generic/GenericCircleIcon"
import { Box, Stack } from "@mui/material"
import { EnvelopeOpen } from "@phosphor-icons/react"
import { useTheme } from "@emotion/react"
import { resendEmail } from "../../../../config/apisauce"
import useNotiStack from "../../../../hooks/useNotiStack"
import { NeedHelp } from "../generic/GenericDialogFooter"
import { GenericResendVerificationForm } from "../generic/GenericResendVerificationForm"

export const Verification = ({ email }) => {
  const { success } = useNotiStack();
  const theme = useTheme();
  const [loading, setLoading] = useState(false);

  const resend = async () => {
    setLoading(true);
    const response = await resendEmail({ email: email });
    if (response.ok) {
      success('Verification resent!');
    }
    setLoading(false);
  };

  return (
    <Fragment>
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} mb={2}>
        <GenericCircleIcon>
          <EnvelopeOpen size={96} weight="thin" color={theme.palette.primary.main} />
        </GenericCircleIcon>
      </Box>
      <Stack gap={3} alignItems={'center'}>
        <GenericResendVerificationForm loadingSend={loading} resend={resend} email={email} />
        <NeedHelp />
      </Stack>
    </Fragment>
  );
};